import { ExclamationCircleIcon } from '@heroicons/react/24/outline';
import React from 'react';
import BaseBanner from '~/components/Chrome/Banners/BaseBanner';

interface Props {}

const CanadianTariffInfoBanner: React.FC<Props> = () => {
  return (
    <BaseBanner className="h-auto border-b border-green-500 bg-white">
      <ExclamationCircleIcon className="h-6 w-6 flex-shrink-0 text-green-500" />
      <div>
        Good news! As of Sept 1, orders from the U.S. to Canada no longer include tariffs, or cross-border fees.
        Checkout always shows your full, final cost.
      </div>
    </BaseBanner>
  );
};

export default CanadianTariffInfoBanner;
